import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PinnedElementDirective } from './pinned-element.directive';
import { PinnedContainerDirective } from './pinned-container.directive';



@NgModule({
  declarations: [
    PinnedElementDirective,
    PinnedContainerDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PinnedElementDirective,
    PinnedContainerDirective
  ]
})
export class PinnedModule { }
